import TurmasIndexPage from "@/Pages/Turmas/index.vue";
import NewEditTurmaPage from "@/Pages/Turmas/NewEditTurmaPage.vue";
import TurmasViewPage from "@/Pages/Turmas/view.vue";
import TurmasDashboard from "@/Pages/Turmas/dashboard.vue";
import TurmasBolsaFamilia from "@/Pages/Turmas/TurmasBolsaFamilia.vue";
import { can } from "@/plugins/can";
import turmasService from "@/Services/TurmasService";

export default [
  {
    path: "/turmas/",
    name: "turmas",
    component: TurmasIndexPage,
  },
  {
    path: "/turmas/create",
    name: "turmas.create",
    component: NewEditTurmaPage,
    props: { editing: false },
  },
  {
    path: "/turmas/edit/:turma_id",
    name: "turmas.edit",
    component: NewEditTurmaPage,
    props: { editing: true },

    async beforeEnter(to, from, next) {
      const { turma_id: turmaId } = to.params;

      try {
        const { fechada } = await turmasService.situacao(turmaId);

        if (fechada) {
          return next({ name: "turmas.view", params: { turma_id: turmaId } });
        }
      } catch (error) {
        console.error("Erro ao verificar a situação da turma:", error);
      }

      return next();
    },
  },
  {
    path: "/turmas/view/:turma_id",
    name: "turmas.view",
    component: TurmasViewPage,
  },
  {
    path: "/turmas/:id/metricas",
    name: "turmas.dashboard",
    component: TurmasDashboard,
  },

  {
    path: "/turmas/:id/bolsa-familia",
    name: "turmas.bolsa_familia",
    component: TurmasBolsaFamilia,
    beforeEnter(to, from, next) {
      if (!can(["bolsaFamilia.index"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
];
